"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearclaimlots = exports.updateclaimlots = exports.listclaimndcmonographs = exports.listprescribedclaims = exports.updatePrescribe = exports.loadPrescribe = void 0;
const endpoint_1 = require("api/endpoint");
const permissions_1 = require("shared/permissions");
exports.loadPrescribe = endpoint_1.createEndpoint()({
    method: "get",
    path: "prescribe/load-prescribe",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_ORDER_CREATE
});
exports.updatePrescribe = endpoint_1.createEndpoint()({
    method: "post",
    path: "order/update-prescribe",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_ORDER_CREATE
});
exports.listprescribedclaims = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_CLAIM_READ,
    method: "get",
    path: "prescribe/listprescribedclaims"
});
exports.listclaimndcmonographs = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: "put",
    path: "prescribe/listclaimndcmonographs"
});
exports.updateclaimlots = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: "put",
    path: "prescribe/updateclaimlots"
});
exports.clearclaimlots = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: "put",
    path: "prescribe/clearclaimlots"
});



//////////////////
// WEBPACK FOOTER
// ./src/api/prescribe/prescribe-client.ts
// module id = 996
// module chunks = 0 1 2